import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { getStyles } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

import Logo from '../../Logo/Logo';
import NavItems from '../NavItems/NavItems';
// import MenuToggleButton from '../MenuToggleButton/MenuToggleButton';
import SearchFocus from '../SearchFocus/SearchFocus';

import localStyles from './Toolbar.scss';
const styles = getStyles(localStyles);

const toolbar = (props) => (
    <header className={styles('header')} id="header"  onClick={props.onVoid}>
        <div className={styles('header__grid', 'flex', 'flex--justify-between', 'flex--align-center', 'b--white')}>

            <div className={styles('header__col')}>
                <NavLink to="/" exact activeClassName='active' className={styles('header__logo')}>
                    <Logo custom={!!props.communityDetailsData && props.communityDetailsData.applicationCustomization.logoImageReference ? props.communityDetailsData.applicationCustomization.logoImageReference.source : null} loading={props.communityDetailsLoading} />
                </NavLink>
            </div>

            <div className={styles('portrait', 'header__search')}>
                <SearchFocus id={'desktop-search'} />
            </div>

            <NavItems />
        </div>

        {props.isMobileSearchOpen ? (
            <div className={styles(['header__mobile-search', 'b--white', 'mobile-only'])}>
                <SearchFocus id={'mobile-search'} />
            </div>
        ) : null}
    </header>
);

toolbar.propTypes = {
    // properties
    communityDetailsData: PropTypes.object,
    communityDetailsLoading: PropTypes.bool,
    isMobileSearchOpen: PropTypes.bool,

    // functions
    onSetGlobalState: PropTypes.func.isRequired,
    onVoid: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        communityDetailsLoading: state.details.community.loading,
        isMobileSearchOpen: state.global.isMobileSearchOpen,
        communityDetailsData: state.details.community.data
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(toolbar);




// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.js